export default __webpack_public_path__ + "static/media/my-garden-header.44b0bd6d.jpg";